






















































import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      discountPercent: 0 as number,
      taxPercent: 0 as number,
      shippingDollarAmount: 0 as number,
    };
  },
  mounted() {
    this.propsToData();
  },
  props: {
    addModal: {
      required: true,
      type: Boolean,
    },
    addOrEditModal: {
      required: true,
      type: String,
    },
    modalType: {
      required: true,
      type: String,
    },
    discountPercentProp: {
      required: false,
      type: [Number, String],
    },
    taxPercentProp: {
      required: false,
      type: [Number, String],
    },
    shippingDollarAmountProp: {
      required: false,
      type: [Number, String],
    },
  },
  methods: {
    save() {
      if (!this.isValid()) {
        return;
      }
      switch (this.modalType) {
        case 'Discount':
          this.$emit('saveValue', this.discountPercent, this.modalType);
          break;
        case 'Tax':
          this.$emit('saveValue', this.taxPercent, this.modalType);
          break;
        default:
          this.$emit('saveValue', this.shippingDollarAmount, this.modalType);
          break;
      }
    },
    propsToData() {
      if (this.discountPercentProp) {
        this.discountPercent = this.discountPercentProp as any;
      }
      if (this.shippingDollarAmountProp) {
        this.shippingDollarAmount = this.shippingDollarAmountProp as any;
      }
      if (this.taxPercentProp) {
        this.taxPercent = this.taxPercentProp as any;
      }
    },
    isValid(): boolean {
      return (this.$refs.form as any).validate();
    },
  },
  computed: {
    value: {
      get(): any {
        switch (this.modalType) {
          case 'Discount':
            return this.discountPercent;
          case 'Tax':
            return this.taxPercent;
          default:
            return this.shippingDollarAmount;
        }
      },
      set(value: any) {
        switch (this.modalType) {
          case 'Discount':
            this.discountPercent = value;
            break;
          case 'Tax':
            this.taxPercent = value;
            break;
          default:
            this.shippingDollarAmount = value;
            break;
        }
      },
    },

  },
});
